import React from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { clickLogout } from '../../../actions/auth'

const NavbarItemUser = ({ auth, clickLogout }) =>
  auth.isLoggedIn && (
    <div className="navbar-item has-dropdown is-hoverable">
      <a className="navbar-link">{_.get(auth, 'user.displayName')}</a>
      <div className="navbar-dropdown">
        <a className="navbar-item" onClick={clickLogout}>
          Sign out
        </a>
      </div>
    </div>
  )

export default connect(
  ({ auth }) => ({ auth }),
  { clickLogout },
)(NavbarItemUser)



// WEBPACK FOOTER //
// ./src/components/templates/navbar/NavbarItemUser.js